import { useEffect, useRef } from 'react'

import { recordVisit } from '@/services/admin/publicApi'

type Options = {
  path: string
  referer?: string | null
  enabled?: boolean
}

/**
 * Sends a single visit event per path change to the Laravel API (IP resolved server-side).
 * Skips when `VITE_API_BASE_URL` is unset or request fails silently in production UX.
 */
export function useVisitTracking({ path, referer, enabled = true }: Options) {
  const last = useRef<string | null>(null)

  useEffect(() => {
    if (!enabled) {
      return
    }
    if (!import.meta.env.VITE_API_BASE_URL) {
      return
    }
    if (last.current === path) {
      return
    }
    last.current = path

    void recordVisit(path, referer ?? (typeof document !== 'undefined' ? document.referrer : null)).catch(() => {
      /* ignore */
    })
  }, [enabled, path, referer])
}
